<template>
  <div id="sellerStoreSettingPage">
    <v-main class="overflow-hidden">
      <BackBar/>
      <div class="container-fluid px-1">
        <div class="row">
          <div class="col-12 col-md-6 mx-auto pt-0">
            <div class="row ">
              <div class="col-12">
                <div class="bg-white py-5 px-3 rounded-lg">
                  <i class="fa-solid fa-gear fa-2xl transform-icon-to-top"></i>
                  <span class="font16px mr-2 font-weight-bold">تنظیمات فروشگاه</span>
                </div>
              </div>
              <div class="col-4 text-center font-weight-bold">
                <span :class="storeBoardTab ? 'profile-active-tab':''" class="pointer font13px"
                      @click="showStoreBoardTab">تابلوی فروشگاه</span>
              </div>
              <div class="col-4 text-center font-weight-bold px-1">
                <span :class="activateStoreTab ? 'profile-active-tab':''" class="pointer font13px"
                      @click="showActivateStoreTab">فعال سازی فروشگاه</span>
              </div>
              <div class="col-4 text-center font-weight-bold">
                <span :class="purchaseReportTab ? 'profile-active-tab':''" class="pointer font13px"
                      @click="showPurchaseReportTab">گزارش خرید</span>
              </div>
              <v-form v-if="storeBoardTab" ref="storeBoard" class="col-12">
                <div class="row align-items-center">
                  <div class="col-8 pr-10">
                    <i class="fa-solid fa-period"></i>
                    عکس لوگو فروشگاه خود را انتخاب کنید
                    <div class="mt-2 pr-2">عکس مربع باشد</div>
                  </div>
                  <div class="col-4 text-left pl-10">
                    <input v-show="false" id="ImageFileUrl" ref="inputUpload"
                           name="ImageFileUrl" type="file"
                           @change="attachmentSelected($event,1)">
                    <v-avatar size="75">
                      <img v-if="selectedImage !== null" :src="selectedImage" alt="تصویر لوگو فروشگاه">
                      <i v-else class="fas fa-circle-user fa-6x"></i>
                    </v-avatar>
                    <v-btn class="edit-photo-btn" icon @click="$refs.inputUpload.click()"><i
                        class="fa-solid fa-pen-to-square fa-2xl"></i></v-btn>

                  </div>
                </div>
                <div class="row">
                  <div class="col-12 py-1">
                    <div class="mr-2 mb-2">نام فروشگاه *</div>
                    <v-text-field v-model="storeName" :rules="MandatoryFieldRule" dense flat solo>
                    </v-text-field>
                  </div>
                  <div class="col-12 py-1">
                    <div class="mr-2 mb-2">تلفن ثابت *</div>
                    <v-text-field v-model="storePhone" :rules="MandatoryFieldRule" dense flat solo>
                    </v-text-field>
                  </div>
                  <div class="col-12 py-1">
                    <div class="mr-2 mb-2">تلفن همراه *</div>
                    <v-text-field v-model="storeMobile" :rules="phoneNumberRules" dense flat solo>
                    </v-text-field>
                  </div>
                  <div class="col-12 py-1 mb-6">
                    <div class="mr-2 mb-2">بیوگرافی یا شعار فروشگاه *</div>
                    <editor-content :editor="storeBioEditor" class="text-editor"/>
                  </div>
                  <div class="col-6 py-1">
                    <div class="mr-2 mb-2">استان *</div>
                    <v-autocomplete v-model="provinceId" :items="provinceItems" :rules="MandatoryFieldRule" dense
                                    flat item-text="Text" item-value="Value"
                                    solo @change="findIndexSelectedCity()">
                    </v-autocomplete>
                  </div>
                  <div class="col-6 py-1">
                    <div class="mr-2 mb-2">شهر *</div>
                    <v-autocomplete v-model="cityId" :items="cities" :rules="MandatoryFieldRule" dense
                                    flat item-text="Text"
                                    item-value="Value" solo>
                    </v-autocomplete>
                  </div>
                  <div class="col-12 py-1">
                    <div class="mr-2 mb-2">نشانی *</div>
                    <v-textarea v-model="storeAddress" :rules="MandatoryFieldRule" auto-grow dense flat rows="4" solo>
                    </v-textarea>
                  </div>
                  <div class="col-3 py-1">
                    <div class="mr-2 mb-2">پلاک *</div>
                    <v-text-field v-model="storeNo" :rules="MandatoryFieldRule" dense flat solo>
                    </v-text-field>
                  </div>
                  <div class="col-3 py-1">
                    <div class="mr-2 mb-2">واحد *</div>
                    <v-text-field v-model="storeUnit" :rules="MandatoryFieldRule" dense flat solo>
                    </v-text-field>
                  </div>
                  <div class="col-6 py-1">
                    <div class="mr-2 mb-2">کدپستی *</div>
                    <v-text-field v-model="storeZipCode" :rules="MandatoryFieldRule" dense flat solo>
                    </v-text-field>
                  </div>
                  <div class="col-12 py-0">
                    <v-checkbox
                        v-model="isAccepted"
                        class="mt-0">
                      <template slot="label">
                        <div>
                          آیا ارسال توسط سیستم محاسبه گردد؟ (سیستم هوشمند)
                        </div>
                      </template>
                    </v-checkbox>
                  </div>
                  <div class="col-12 pt-0 text-center font12px">
                    توجه: با فعال کردن این گزینه به طور هوشمند و بر اساس <span
                      class="red--text text-decoration-underline"> حجم و وزن</span> کالا نوع ماشین محاسبه
                    میگردد و در <span class="red--text text-decoration-underline"> سبد خرید</span> به مشتری نمایش داده
                    میشود،لذا مهم است شما
                    <span class="red--text text-decoration-underline">وزن و اندازه کالا </span> خود را به طور دقیق در
                    بخش محصولات وارد نمایید.
                  </div>

                  <div class="col-12 pt-5">
                    <div class="text-center"><span>&#10070;</span> محل فروشگاه خود را ثبت کنید</div>
                    <v-btn class="loc-btn" icon @click="getCurrentLocation">
                      <i class="fas fa-location pl-1 white--text "></i>
                    </v-btn>
                    <GmapMap
                        ref="mapRef"
                        :center="myCoordinates"
                        :options='{ fullscreenControl: false, mapTypeControl: false }'
                        :zoom="zoom"
                        class="mt-6 rounded-lg"
                        style="height:360px"
                        @click="mark">

                      <GmapMarker
                          v-for='(marker,index) in markers'
                          :key="index"
                          :animation="2"
                          :clickable="true"
                          :position="marker"
                          @click="center=marker"/>
                    </GmapMap>
                  </div>
                  <div class="col-12">
                    <div class="row">
                      <div class="col-auto">
                        <v-btn icon @click="$refs.inputUploadStoreLogo.click()"><i
                            class="fa-solid fa-pen-to-square fa-2xl"></i></v-btn>
                        <i class="fa-solid fa-period"></i>
                        عکس پروانه کسب خود را آپلود کنبد
                        <input v-show="false" ref="inputUploadStoreLogo"
                               type="file"
                               @change="attachmentSelected($event,2)">
                      </div>
                      <div class="col ">
                        <v-img :src="selectedStoreImage" alt="پروانه کسب"
                               class="mx-auto rounded-lg" cover height="100" width="100"></v-img>
                      </div>
                    </div>
                  </div>
                  <div class="col-12">
                    <div class="mr-2 mb-2">بازارچه فروشگاه خود را انتخاب کنید *</div>
                    <v-autocomplete v-model="shoppingId" :items="shoppingCategoriesArr" :rules="MandatoryFieldRule"
                                    dense flat item-text="Text"
                                    item-value="Value" solo>
                    </v-autocomplete>
                  </div>
                  <div class="col-12">
                    <v-btn block color="primary" @click="editStoreBoardData">
                      ثبت
                    </v-btn>
                  </div>
                </div>
              </v-form>
              <div v-if="activateStoreTab" class="col-12">
                <div class="row">
                  <div v-for="(item,i) in activateItems" :key="i" class="col-12 py-1">
                    <div class="bg-white rounded-lg p-3 py-2">
                      <div class="row">
                        <div class="col-3 py-1">
                          <v-img :src="$replaceHttps(item.FileUrl)"></v-img>
                        </div>
                        <div class="col-9 py-1">
                          <i class="fa-solid fa-period"></i>
                          <span class="mr-1 font-weight-bold">{{ item.Name }}</span>
                          <span class="discount-on-card ">
                          <span v-if="item.Discount !== 0" class="product-card-discount rounded-circle ">
                            {{ item.Discount }} %</span>
                        </span>
                          <div class="mt-1" v-html="item.Description"></div>
                        </div>
                        <div class="col-12">
                          <i class="fa-solid fa-period"></i>
                          <span class="mr-1 font-weight-bold">تعداد روز فعال: {{ item.ActiveDay }} روز</span>
                          <span v-if="item.Price !== 0" class="float-left">
                        <span class="font-weight-bold">{{ $computingPriceOffer(item.Price, item.Discount) }}</span>
                            <span v-if="item.Discount !== 0" class="font12px text-decoration-line-through mr-2">
                              {{ $numberWithCommas(item.Price) }}</span>
                          </span>
                          <span v-else class="float-left">
                      رایگان
                          </span>
                        </div>
                        <div class="col-12">
                          <v-btn block color="primary" @click="buyPlan(item.PlanID)">
                            خرید
                          </v-btn>
                        </div>
                      </div>
                    </div>

                  </div>
                </div>
              </div>
              <div v-if="purchaseReportTab" class="col-12">
                <div class="row">
                  <div v-if="purchaseReportItems.length <= 0" class="col-12  text-center">
                    <div><i class="fa-light fa-face-frown-slight fa-3x grey--text"></i></div>
                    <div class="mt-2">
                     گزارشی وجود ندارد
                    </div>

                  </div>
                  <div v-else v-for="(item,i) in purchaseReportItems" :key="i" class="col-12 py-1">
                    <div class="bg-white rounded-lg p-3 py-2">
                      <div class="row">
                        <div class="col-3 py-1">
                          <v-img :src="$replaceHttps(item.FileUrl)"></v-img>
                        </div>
                        <div class="col-9 py-1">
                          <i class="fa-solid fa-period"></i>
                          <span class="mr-1 font-weight-bold">{{ item.Name }}</span>
                          <span class="discount-on-card ">
                          <span v-if="item.Discount !== 0" class="product-card-discount rounded-circle ">
                            {{ item.Discount }} %</span>
                        </span>
                          <div class="mt-1" v-html="item.Description"></div>
                        </div>
                        <div class="col-12">
                          <i class="fa-solid fa-period"></i>
                          <span class="mr-1 font-weight-bold">تعداد روز فعال: {{ item.ActiveDay }} روز</span>
                          <span v-if="item.Price !== 0" class="float-left">
                        <span class="font-weight-bold">{{ $computingPriceOffer(item.Price, item.Discount) }}</span>
                            <span v-if="item.Discount !== 0" class="font12px text-decoration-line-through mr-2">
                              {{ $numberWithCommas(item.Price) }}</span>
                          </span> <span v-else class="float-left">
                        رایگان
                          </span>
                        </div>
                        <div class="col-6 px-1">
                          <v-btn block color="primary" depressed>
                            تاریخ خرید: {{ $convertDate(item.ModifiedDate) }}
                          </v-btn>
                        </div>
                        <div class="col-6 px-1">
                          <v-btn block color="primary" depressed>
                            تاریخ انقضا: {{ $convertDate(item.expireDate)  }}
                          </v-btn>
                        </div>
                      </div>
                    </div>

                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </v-main>
    <v-overlay :value="showLoaderDialog">
      <div class="loading-spinner">
      </div>
    </v-overlay>
    <v-snackbar
        v-model="showResult"
        :multi-line="true"
        color="primary">
      <div v-html="resultText">

      </div>
      <template v-slot:action="{ attrs }">
        <v-btn v-bind="attrs" icon @click="showResult = false ">
          <i class="fa-solid fa-circle-xmark fa-xl white--text"></i>
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import BackBar from "@/components/BackBar";
import {Editor, EditorContent} from 'tiptap';


export default {
  name: "SellerStoreSetting",
  metaInfo: {
    title: 'ایوان خانه- تنظیمات فروشگاه',
  },
  components: {BackBar, EditorContent},
  data: () => ({
    MandatoryFieldRule: [v => !!v || 'فیلد اجباری'],
    showLoaderDialog: false,
    showResult: false,
    resultText: '',
    storeBoardTab: true,
    activateStoreTab: false,
    purchaseReportTab: false,
    selectedImageFilePath: null,
    selectedImage: null,
    selectedImageStoreFilePath: null,
    selectedStoreImage: null,
    storeBioEditor: null,
    storeBio: '',
    map: null,
    markers: [],
    center: {lat: 45.508, lng: -73.587},
    myCoordinates: {
      lat: 35.723524,
      lng: 51.396660
    },
    zoom: 10,
    activateItems: [],
    purchaseReportItems: [],
    phoneNumberRules: [
      v => !!v || 'فیلد اجباری',
      value => (value && value[0] === "0") || 'اولین رقم مبایل به عدد صفر شروع می شود ',
      value => (value && value.length === 11) || 'شماره موبایل 11 رقم است.',
    ],
    storeName: '',
    storeMobile: '',
    storePhone: '',
    provinceItems: [],
    provinceId: '',
    cities: [],
    cityId: '',
    storeAddress: '',
    storeZipCode: '',
    storeNo: '',
    isAccepted: false,
    shoppingId: '',
    shoppingCategoriesArr: [],
    vendorID: null,
    storeUnit: '',
    hasLogoImage: false,
    hasBusinessImage: false,
    appUserID: null,
    typeVendorStatus: null,
  }),
  created() {
    this.$getLocation({})
        .then(coordinates => {
          this.myCoordinates = coordinates;
          this.markers.push(this.myCoordinates)
        })
        .catch(error => console.log(error));
  },
  mounted() {
    this.getStoreBoardData()
    this.getActivateItems()
  },
  methods: {
    showStoreBoardTab() {
      this.storeBoardTab = true;
      this.activateStoreTab = false;
      this.purchaseReportTab = false;
    },
    showActivateStoreTab() {
      this.storeBoardTab = false;
      this.activateStoreTab = true;
      this.purchaseReportTab = false;
    },
    showPurchaseReportTab() {
      this.storeBoardTab = false;
      this.activateStoreTab = false;
      this.purchaseReportTab = true;
      if (this.purchaseReportItems.length === 0) {
        this.getPurchaseReportItems()

      }
    },
    attachmentSelected(e, type) {
      let files = e.target.files;
      if (files.length > 0) {
        this.imageName = files[0].name
        if (this.imageName.lastIndexOf('.') <= 0) {
          return
        }
        const fr = new FileReader()
        fr.readAsDataURL(files[0])
        fr.addEventListener('load', () => {
          if (type === 1) {
            this.hasLogoImage = false
            this.selectedImage = fr.result
            this.selectedImageFilePath = files[0] // this is an image file that can be sent to server...
          } else {
            this.hasBusinessImage = false
            this.selectedStoreImage = fr.result
            this.selectedImageStoreFilePath = files[0] // this is an image file that can be sent to server...
          }
        })
      }

    },
    mark(event) {
      if (this.markers.length > 0) {
        this.markers.pop()
        this.markers.push({lat: event.latLng.lat(), lng: event.latLng.lng()})
      } else {
        this.markers.push({lat: event.latLng.lat(), lng: event.latLng.lng()})
      }
    },
    getCurrentLocation() {
      this.$getLocation({})
          .then(coordinates => {
            this.myCoordinates = coordinates;
            if (this.markers.length > 0) {
              this.markers.pop()
              this.markers.push(this.myCoordinates)
              this.$refs.mapRef.$mapPromise.then(map => map.panTo(coordinates));

            } else {
              this.markers.push(this.myCoordinates)
            }
          })
          .catch(error => console.log(error));
    },
    getStoreBoardData() {
      this.showLoaderDialog = true
      let myHeaders = new Headers();
      myHeaders.append("Authorization", this.$getUserData().token);

      let requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "VendorPanel/Individual/_VendorProfile", requestOptions)
          .then(response => response.text())
          .then(result => {
            let json = JSON.parse(result)
            this.vendorID = json.VendorID
            this.typeVendorStatus = json.TypeVendorStatus
            this.appUserID = json.AppUserID
            this.storeName = json.Name === null ? '' : json.Name
            this.storeMobile = json.MobilePhone === null ? '' : json.MobilePhone
            this.storePhone = json.StaticPhone === null ? '' : json.StaticPhone
            this.selectedImage = json.PictureLogoUrl
            if (this.selectedImage !== null) {
              this.hasLogoImage = true
            }
            this.storeUnit = json.Vahed
            this.storeBioEditor = new Editor({
              content: json.Description,
            })
            this.storeAddress = json.Address === null ? '' : json.Address
            this.storeZipCode = json.ZipCode === null ? '' : json.ZipCode
            this.storeNo = json.Plak === null ? '' : json.Plak
            this.provinceId = json.ProvinceID === null ? '' : json.ProvinceID
            this.cityId = json.CityID === null ? '' : json.CityID
            this.provinceItems = json.Provinces.filter(x => x.Disabled === false)
            this.findIndexSelectedCity()
            this.isAccepted = json.IsSendBySite
            this.markers = [{lat: json.Latitude, lng: json.Longitude}]
            this.center = {lat: json.Latitude, lng: json.Longitude}
            this.selectedStoreImage = json.PictureBusinessUrl === null ? '' : json.PictureBusinessUrl
            if (this.selectedStoreImage !== null) {
              this.hasBusinessImage = true
            }
            this.shoppingId = json.ShoppingCategoryID === null ? '' : json.ShoppingCategoryID
            this.shoppingCategoriesArr = json.ShoppingCategories.filter(x => x.Disabled === false)
            this.showLoaderDialog = false;

          })
          .catch(error => console.log('error', error));
    },
    editStoreBoardData() {
      this.$refs.storeBoard.validate()

      if (this.$refs.storeBoard.validate()) {
        this.showLoaderDialog = true
        let myHeaders = new Headers();
        myHeaders.append("Authorization", this.$getUserData().token);

        let urlencoded = new FormData();
        urlencoded.append("TypeVendorStatus", this.typeVendorStatus);
        urlencoded.append("Name", this.storeName);
        urlencoded.append("StaticPhone", this.storePhone);
        urlencoded.append("MobilePhone", this.storeMobile);
        urlencoded.append("Description", this.storeBioEditor.getHTML());
        urlencoded.append("Address", this.storeAddress);
        urlencoded.append("ZipCode", this.storeZipCode);
        urlencoded.append("Plak", this.storeNo);
        urlencoded.append("Vahed", this.storeUnit);
        urlencoded.append("Latitude", this.markers[0].lat);
        urlencoded.append("Longitude", this.markers[0].lng);
        urlencoded.append("AppUserID", this.appUserID);
        if (this.hasLogoImage) {
          urlencoded.append("PictureLogoUrl", this.selectedImage);
        } else {
          urlencoded.append("ImagePictureLogoUrl", this.selectedImageFilePath);
        }
        if (this.hasBusinessImage) {
          urlencoded.append("PictureBusinessUrl", this.selectedStoreImage);
        } else {
          urlencoded.append("ImagePictureBusinessUrl", this.selectedImageStoreFilePath);
        }
        urlencoded.append("IsSendBySite", this.isAccepted);
        urlencoded.append("ProvinceID", this.provinceId);
        urlencoded.append("CityID", this.cityId);
        urlencoded.append("BranchWorkID", "e8048b5d-35ca-47e5-ed0f-08d9921b7dba");
        urlencoded.append("ShoppingCategoryID", this.shoppingId);


        let requestOptions = {
          method: 'POST',
          headers: myHeaders,
          body: urlencoded,
          redirect: 'follow'
        };
        let resStatus = null
        fetch(this.$baseUrl + "VendorPanel/Individual/_VendorProfile", requestOptions)
            .then(response => {
              resStatus = response.status
              return response.text()
            })
            .then(result => {
              if (resStatus === 200) {
                let json = JSON.parse(result)
                this.resultText = json.Message
              } else {
                this.resultText = result
              }
              this.showLoaderDialog = false
              this.showResult = true
            })
            .catch(error => console.log('error', error));
      }
    },
    getActivateItems() {
      let myHeaders = new Headers();
      myHeaders.append("Authorization", this.$getUserData().token);

      let requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "VendorPanel/Individual/_ListNewBuyPlan", requestOptions)
          .then(response => response.text())
          .then(result => {
            let json = JSON.parse(result)
            this.activateItems = json.filter(x => x.IsActive === true)
          })
          .catch(error => console.log('error', error));
    },
    getPurchaseReportItems() {
      let myHeaders = new Headers();
      myHeaders.append("Authorization", this.$getUserData().token);

      let requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "VendorPanel/Individual/_ListPlanReport", requestOptions)
          .then(response => response.text())
          .then(result => {
            let json = JSON.parse(result)
            for (let i = 0; i < json.length; i++) {
              const date = new Date(json[i].ModifiedDate);
              date.setDate(date.getDate() + json[i].ActiveDay);
              json[i].expireDate = date.toISOString()
            }
            this.purchaseReportItems = json
          })
          .catch(error => console.log('error', error));

    },
    findIndexSelectedCity() {
      let myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

      let urlencoded = new URLSearchParams();
      urlencoded.append("ProvinceID", this.provinceId);

      let requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: urlencoded,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "CommonMethod/LoadCities", requestOptions)
          .then(response => response.text())
          .then(result => {
            let json = JSON.parse(result)
            this.cities = json.filter(x => x.Disabled === false)

          })
          .catch(error => console.log('error', error));
    },
    buyPlan(id) {
      this.showLoaderDialog = true
      let myHeaders = new Headers();
      myHeaders.append("Authorization", this.$getUserData().token);
      myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

      let urlencoded = new URLSearchParams();
      urlencoded.append("PlanID", id);

      let requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: urlencoded,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "VendorPanel/Individual/BuyNew", requestOptions)
          .then(response => response.text())
          .then(result => {
            this.showLoaderDialog = false
            this.resultText= result
            this.showResult= true

          })
          .catch(error => console.log('error', error));
    }


  }
}
</script>

<style scoped>

</style>
